<div class="card shadow-sm">
    <div class="card-body">
        <div class="d-flex align-items-center">
            <h5 class="m-0">{{ 'hub.quotations.details.offer.edit-offer' | translate }}</h5>
        </div>

        <p-messages
            severity="error"
            [enableService]="false"
            class="mt-3 mb-0"
            *ngIf="error$ | async">
            <ng-template pTemplate>
                {{ 'common.generic-error-alt' | translate }}
                <a class="close" (click)="onDismissError()">
                    <fa-icon [icon]="['far', 'times']"></fa-icon>
                </a>
            </ng-template>
        </p-messages>
    </div>

    <div class="card-body">
        <qwyk-quotations-offer-form
            (save)="onUpdate($event)"
            [disabled]="loading$ | async"
            [quotationOffer]="selectedQuotationOffer$ | async"
        ></qwyk-quotations-offer-form>
    </div>
</div>
